var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navs"},[_c('div',{staticClass:"w1228 df"},_vm._l((_vm.nav),function(v,i){return _c('div',{staticClass:"btn",class:{ cur: _vm.page==v.page },on:{"click":function($event){return _vm.tapNav(v.page)}}},[_vm._v(_vm._s(v.name))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd8cc638","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navs/navs.vue
// module id = null
// module chunks = 